import { useEffect, useState } from "react";

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const mql = window.matchMedia("(max-width: 767px)");
    setIsMobile(mql.matches);
    const onChange = (e) => setIsMobile(e.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);
  return isMobile;
};

export const useIsPortraitExperience = () => {
  const [isPortrait, setIsPortrait] = useState(false);
  useEffect(() => {
    const mql = window.matchMedia(
      "(max-width: 768px), (orientation: portrait)",
    );
    setIsPortrait(mql.matches);
    const onChange = (e) => setIsPortrait(e.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);
  return isPortrait;
};

export const useIsTabletPortrait = () => {
  const [isTabletPortrait, setIsTabletPortrait] = useState(false);
  useEffect(() => {
    const mql = window.matchMedia(
      "(min-width: 769px) and (max-width: 1200px) and (orientation: portrait)",
    );
    setIsTabletPortrait(mql.matches);
    const onChange = (e) => setIsTabletPortrait(e.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);
  return isTabletPortrait;
};

export const useHasMounted = () => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  return mounted;
};
